import React, { useState, useEffect } from 'react';
import { ref, get, push, set, update, remove } from 'firebase/database';
import { database } from '../firebase/config';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import PulsantiCondivisionePDF from './PulsantiCondivisionePDF';
import '../styles/Liste.css';
import { formattaData } from '../utils/dateUtils'; 
import { useFirebaseData } from '../hooks/useFirebaseData'; 
import { useAuth } from '../contexts/AuthContext';
import VisualizzaBolle from './admin/VisualizzaBolle';
import VisualizzaGiornaliera from './admin/VisualizzaGiornaliera';
import VisualizzaFotoCantiere from './admin/VisualizzaFotoCantiere';
import VisualizzaBolleForm from './admin/VisualizzaBolleForm';

// Stili per il PDF del report dipendente
const pdfStyles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica'
  },
  header: {
    fontSize: 18,
    marginBottom: 10,
    textAlign: 'center',
    color: '#2c3e50',
    fontWeight: 'bold'
  },
  subheader: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: '#7f8c8d'
  },
  infoBox: {
    backgroundColor: '#e3f2fd',
    padding: 10,
    marginBottom: 15,
    borderRadius: 5
  },
  infoText: {
    fontSize: 11,
    textAlign: 'center',
    fontWeight: 'bold'
  },
  table: {
    display: 'table',
    width: '100%',
    marginTop: 10
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#dee2e6',
    minHeight: 25,
    alignItems: 'center'
  },
  tableHeader: {
    backgroundColor: '#f8f9fa',
    fontWeight: 'bold',
    fontSize: 9
  },
  tableCol: {
    padding: 5,
    fontSize: 8
  },
  col1: { width: '10%' },
  col2: { width: '8%' },
  col3: { width: '8%' },
  col4: { width: '8%' },
  col5: { width: '14%' },
  col6: { width: '14%' },
  col7: { width: '14%' },
  col8: { width: '24%' },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    textAlign: 'center',
    fontSize: 8,
    color: '#95a5a6'
  }
});


function ListaDipendenti() {
  const [dipendenti, setDipendenti] = useState([]);
  const { veicoli, cantieri, clienti,          
    caricaVeicoli, caricaCantieri, caricaClienti
  } = useFirebaseData();
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    nome: '',
    cognome: '',
    email: ''
});

  const [showReportModal, setShowReportModal] = useState(false);
  const [dipendenteSelezionato, setDipendenteSelezionato] = useState(null);
  const [programmiDipendente, setProgrammiDipendente] = useState([]);
  const [ordinamentoReport, setOrdinamentoReport] = useState({
    campo: 'data',
    direzione: 'desc'
  });

const { creaDipendente, resetPasswordDipendente } = useAuth();  // ← AGGIUNTO

// Stato per la vista documenti dipendente (admin)
const [vistaDocumenti, setVistaDocumenti] = useState(null);     // ← AGGIUNTO
const [showPasswordModal, setShowPasswordModal] = useState(false);
const [dipPasswordSelezionato, setDipPasswordSelezionato] = useState(null);

// { tipo: 'bolle'|'giornaliera'|'foto', dipendente: {...} }


  // Carica i dipendenti dal database
  useEffect(() => {
    caricaDipendenti();
  }, []);

  async function caricaDipendenti() {
    const dipendentiRef = ref(database, 'dipendenti');
    const snapshot = await get(dipendentiRef);
    
    if (snapshot.exists()) {
      const data = snapshot.val();
      const dipendentiArray = Object.keys(data).map(key => ({ id: key, ...data[key] }));
dipendentiArray.sort((a, b) => (a.cognome || '').localeCompare(b.cognome || '', 'it', { sensitivity: 'base' }));
setDipendenti(dipendentiArray);

    } else {
      setDipendenti([]);
    }
  }

function apriModal(dipendente = null) {
  if (dipendente) {
    setEditingId(dipendente.id);
    setFormData({
      nome: dipendente.nome,
      cognome: dipendente.cognome,
      email: dipendente.email || ''
    });
  } else {
    setEditingId(null);
    setFormData({ nome: '', cognome: '', email: '' });
  }
  setShowModal(true);
}


function chiudiModal() {
  setShowModal(false);
  setEditingId(null);
  setFormData({ nome: '', cognome: '', email: '' });
}


async function handleSubmit(e) {
  e.preventDefault();
  if (!formData.nome || !formData.cognome) {
    alert('Compila tutti i campi obbligatori');
    return;
  }
  // Email obbligatoria solo in creazione
  if (!editingId && !formData.email) {
    alert('Inserisci una email per il dipendente');
    return;
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (formData.email && !emailRegex.test(formData.email)) {
    alert("Inserisci un'email valida");
    return;
  }

  try {
    if (editingId) {
      // Modifica dipendente esistente
      const dipendenteRef = ref(database, `dipendenti/${editingId}`);
      const aggiornamento = {
        nome: formData.nome,
        cognome: formData.cognome,
      };
      if (formData.email) aggiornamento.email = formData.email;
      await update(dipendenteRef, aggiornamento);
      alert('Dipendente modificato con successo!');
} else {
  const dipendentiRef = ref(database, 'dipendenti');
  const newDipendenteRef = push(dipendentiRef);
  const dipendenteId = newDipendenteRef.key;

  // Prima crea l'account Auth e ottieni la password
  const result = await creaDipendente(formData.email, dipendenteId);

  // Poi salva nel DB includendo la password
  await set(newDipendenteRef, {
    nome: formData.nome,
    cognome: formData.cognome,
    email: formData.email,
    passwordTemp: result.passwordTemp,   // ← salvata nel DB
    createdAt: Date.now(),
  });

  alert(
    `✅ Dipendente creato!\n\n` +
    `📧 Email: ${formData.email}\n` +
    `🔑 Password: ${result.passwordTemp}\n\n` +
    `Comunica queste credenziali al dipendente.\n` +
    `Il dipendente può cambiare password usando "Password dimenticata?" nel login.`
  );
}                 // ← chiude l'else
    chiudiModal();
    caricaDipendenti();
  } catch (error) {

    if (error.code === 'auth/email-already-in-use') {
      alert('Questa email è già registrata nel sistema');
    } else {
      alert('Errore: ' + error.message);
    }
  }
}

async function eliminaDipendente(id, nome, cognome) {
  if (window.confirm(`Sei sicuro di voler eliminare ${nome} ${cognome}?`)) {
    try {
      // 1. Trova l'uid cercando in users/ per dipendenteId
      const usersSnap = await get(ref(database, 'users'));
      if (usersSnap.exists()) {
        const users = usersSnap.val();
        const uid = Object.keys(users).find(
          key => users[key].dipendenteId === id
        );
        if (uid) {
          // 2. Cancella il nodo users/{uid}
          await remove(ref(database, `users/${uid}`));
        }
      }
      // 3. Cancella il record dipendente
      await remove(ref(database, `dipendenti/${id}`));
      alert('Dipendente eliminato! Ricorda di eliminare l\'utente anche da Firebase Authentication.');
      caricaDipendenti();
    } catch (error) {
      alert('Errore: ' + error.message);
    }
  }
}


  async function apriReportDipendente(dipendente) {
    setDipendenteSelezionato(dipendente);
    setShowReportModal(true);
    
    // Carica tutti i dati necessari
    await Promise.all([
      caricaProgrammiDipendente(dipendente.id),
      caricaVeicoli(),
      caricaCantieri(),
      caricaClienti()
    ]);
  }

  async function caricaProgrammiDipendente(dipendenteId) {
    try {
      const programmiRef = ref(database, 'programmi-lavorativi');
      const snapshot = await get(programmiRef);
      
      if (snapshot.exists()) {
        const data = snapshot.val();
        const programmiArray = Object.keys(data)
          .map(key => ({ id: key, ...data[key] }))
          .filter(prog => prog.dipendenteId === dipendenteId)
          .sort((a, b) => new Date(b.data) - new Date(a.data));
        
        setProgrammiDipendente(programmiArray);
      } else {
        setProgrammiDipendente([]);
      }
    } catch (error) {
      console.error('Errore caricamento programmi:', error);
      setProgrammiDipendente([]);
    }
  }



  function chiudiReportModal() {
    setShowReportModal(false);
    setDipendenteSelezionato(null);
    setProgrammiDipendente([]);
  }

  function getVeicolo(id) {
    return veicoli.find(v => v.id === id);
  }

  function getCantiere(id) {
    return cantieri.find(c => c.id === id);
  }

  function getCliente(cantiereId) {
    const cantiere = getCantiere(cantiereId);
    return cantiere ? clienti.find(c => c.id === cantiere.clienteId) : null;
  }


  function handleOrdinamentoReport(campo) {
    let direzione = 'asc';
    
    if (ordinamentoReport.campo === campo && ordinamentoReport.direzione === 'asc') {
      direzione = 'desc';
    }
    
    setOrdinamentoReport({ campo, direzione });
  }

  function getProgrammiOrdinati() {
    const programmiCopia = [...programmiDipendente];
    
    programmiCopia.sort((a, b) => {
      let valoreA, valoreB;
      
      if (ordinamentoReport.campo === 'data') {
        valoreA = new Date(a.data);
        valoreB = new Date(b.data);
      } else if (ordinamentoReport.campo === 'veicolo') {
        const veicA = getVeicolo(a.veicoloId);
        const veicB = getVeicolo(b.veicoloId);
        valoreA = veicA ? `${veicA.marca} ${veicA.modello}`.toLowerCase() : '';
        valoreB = veicB ? `${veicB.marca} ${veicB.modello}`.toLowerCase() : '';
      } else if (ordinamentoReport.campo === 'cliente') {
        const cliA = getCliente(a.cantiereId);
        const cliB = getCliente(b.cantiereId);
        valoreA = cliA ? cliA.ragioneSociale.toLowerCase() : '';
        valoreB = cliB ? cliB.ragioneSociale.toLowerCase() : '';
      } else if (ordinamentoReport.campo === 'cantiere') {
        const cantA = getCantiere(a.cantiereId);
        const cantB = getCantiere(b.cantiereId);
        valoreA = cantA ? cantA.luogo.toLowerCase() : '';
        valoreB = cantB ? cantB.luogo.toLowerCase() : '';
      }
      
      if (valoreA < valoreB) {
        return ordinamentoReport.direzione === 'asc' ? -1 : 1;
      }
      if (valoreA > valoreB) {
        return ordinamentoReport.direzione === 'asc' ? 1 : -1;
      }
      return 0;
    });
    
    return programmiCopia;
  }

  function getFrecciaReport(campo) {
    if (ordinamentoReport.campo !== campo) {
      return '↕️';
    }
    return ordinamentoReport.direzione === 'asc' ? '🔼' : '🔽';
  }

  // Componente PDF per Report Dipendente
  const ReportDipendentePDF = ({ dipendente, programmi }) => (
    <Document>
      <Page size="A4" orientation="landscape" style={pdfStyles.page}>
        <Text style={pdfStyles.header}>Report Programmi Lavorativi</Text>
        <Text style={pdfStyles.subheader}>
          {dipendente.nome} {dipendente.cognome}
        </Text>
        
        <View style={pdfStyles.infoBox}>
          <Text style={pdfStyles.infoText}>
            Totale Programmi: {programmi.length}
          </Text>
        </View>

        <View style={pdfStyles.table}>
          <View style={[pdfStyles.tableRow, pdfStyles.tableHeader]}>
            <Text style={[pdfStyles.tableCol, pdfStyles.col1]}>Data</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col2]}>Inizio</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col3]}>Fine</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col4]}>Durata</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col5]}>Veicolo</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col6]}>Cliente</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col7]}>Cantiere</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col8]}>Note</Text>
          </View>

          {programmi.map((prog, index) => {
            const veicolo = getVeicolo(prog.veicoloId);
            const cantiere = getCantiere(prog.cantiereId);
            const cliente = getCliente(prog.cantiereId);

            return (
              <View key={index} style={pdfStyles.tableRow}>
                <Text style={[pdfStyles.tableCol, pdfStyles.col1]}>{formattaData(prog.data)}</Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col2]}>{prog.orarioInizio}</Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col3]}>{prog.orarioFine}</Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col4]}>{prog.durataLavoro}</Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col5]}>
                  {veicolo ? `${veicolo.marca} ${veicolo.modello} (${veicolo.targa})` : 'N/D'}
                </Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col6]}>
                  {cliente ? cliente.ragioneSociale : 'N/D'}
                </Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col7]}>
                  {cantiere ? cantiere.luogo : 'N/D'}
                </Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col8]}>
                  {prog.note || '-'}
                </Text>
              </View>
            );
          })}
        </View>

        <Text style={pdfStyles.footer}>
          Report generato il {new Date().toLocaleDateString('it-IT')} alle {new Date().toLocaleTimeString('it-IT')}
        </Text>
      </Page>
    </Document>
  );


  return (
    <div className="lista-container">
      <div className="lista-header">
        <h2>👥 Gestione Dipendenti</h2>
        <button className="btn-add" onClick={() => apriModal()}>
          + Aggiungi Dipendente
        </button>
      </div>

      {dipendenti.length === 0 ? (
        <div className="empty-state">
          <p>Nessun dipendente presente.</p>
          <p>Clicca su "Aggiungi Dipendente" per iniziare.</p>
        </div>
      ) : (
        <>
          {/* Tabella Desktop */}
          <table className="data-table">
            <thead>
              <tr>
                <th>Cognome</th>
                <th>Nome</th>
		<th>Email</th>  
                <th>Azioni</th>
                <th>Password</th>
                <th>Doc. lavori</th>
              </tr>
            </thead>
            <tbody>
              {dipendenti.map(dip => (
                <tr key={dip.id}>
                  <td>{dip.cognome}</td>
                  <td>{dip.nome}</td>
		  <td>{dip.email || '—'}</td> 
                  <td className="actions">
                    <button 
                      className="btn-edit"
                      onClick={() => apriReportDipendente(dip)}
                      style={{background: '#9b59b6'}}
                    >
                      <img src="/icon-report.svg" alt="pdf" style={{ width: '40px' }} />
                    </button>
                    <button 
                      className="btn-edit"
                      onClick={() => apriModal(dip)}
                    >
                      <img src="/icon-edit.svg" alt="pdf" style={{ width: '40px' }} />
                    </button>
                    <button 
                      className="btn-delete"
                      onClick={() => eliminaDipendente(dip.id, dip.nome, dip.cognome)}
                    >
                      <img src="/icon-delete.svg" alt="pdf" style={{ width: '40px' }} />
                    </button>
		   </td>


<td className="actions">
{/* Pulsante reset password */}
<button
  onClick={async () => {
    if (window.confirm(`Inviare email reset password a ${dip.email}?`)) {
      try {
        await resetPasswordDipendente(dip.email);
        alert('Email di reset inviata!');
      } catch (e) {
        alert('Errore: ' + e.message);
      }
    }
  }}
  className="btn-documenti"
  title="Reset Password"
>
  <img src="/icon-reset-password.svg" alt="reset pwd" style={{ height: '40px' }} />
</button>

<button
  onClick={() => { setDipPasswordSelezionato(dip); setShowPasswordModal(true); }}
  className="btn-documenti"
  title="Mostra credenziali"
>
  <img src="/icon-show-password.svg" alt="show pwd" style={{ height: '40px' }} />
</button>



	           </td>

                  <td className="actions">
<p>
  <button className="btn-delete" onClick={() => setVistaDocumenti({ tipo: 'bolle', dipendente: dip })}>
      <img src="/icon-pesa.svg" alt="bolle" style={{ height: '30px' }} />
  </button>
  <button className="btn-delete" onClick={() => setVistaDocumenti({ tipo: 'giornaliera', dipendente: dip })}>
      <img src="/icon-giornaliera.svg" alt="giornaliera" style={{ height: '30px' }} />
  </button>
  <button className="btn-delete" onClick={() => setVistaDocumenti({ tipo: 'foto', dipendente: dip })}>
      <img src="/icon-foto.svg" alt="foto cantiere" style={{ height: '30px' }} />
  </button>
  <button className="btn-delete" onClick={() => setVistaDocumenti({ tipo: 'creaBolla', dipendente: dip })}>
      <img src="/icon-bolle.svg" alt="bolle" style={{ height: '30px' }} />
  </button>
</p>


                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Layout Card Mobile */}
          <div className="mobile-cards">
            {dipendenti.map(dip => (
              <div key={dip.id} className="mobile-card">
                <div className="mobile-card-header">
                  👤 {dip.nome} {dip.cognome}
                </div>
                
                <div className="mobile-card-actions">
                  <p><button 
                    className="btn-edit"
                    onClick={() => apriReportDipendente(dip)}
                    style={{background: '#9b59b6'}}
                  >
                    <img src="/icon-report.svg" alt="pdf" style={{ width: '40px' }} />
                  </button>
                  <button 
                    className="btn-edit"
                    onClick={() => apriModal(dip)}
                  >
                    <img src="/icon-edit.svg" alt="pdf" style={{ width: '40px' }} />
                  </button>
                  <button 
                    className="btn-delete"
                    onClick={() => eliminaDipendente(dip.id, dip.nome, dip.cognome)}
                  >
                    <img src="/icon-delete.svg" alt="pdf" style={{ width: '40px' }} />
                  </button></p>

  {/* ← AGGIUNGI QUESTI */}
  <p><button className="btn-delete" onClick={() => { setDipPasswordSelezionato(dip); setShowPasswordModal(true); }}>
     <img src="/icon-show-password.svg" alt="show pwd" style={{ height: '40px' }} />
  </button>
  <button className="btn-delete" onClick={() => resetPasswordDipendente(dip.email)}>
      <img src="/icon-reset-password.svg" alt="reset pwd" style={{ height: '40px' }} />
  </button></p>
  <p><button className="btn-delete" onClick={() => setVistaDocumenti({ tipo: 'bolle', dipendente: dip })}>
      <img src="/icon-pesa.svg" alt="bolle" style={{ height: '40px' }} />
  </button>
  <button className="btn-delete" onClick={() => setVistaDocumenti({ tipo: 'giornaliera', dipendente: dip })}>
      <img src="/icon-giornaliera.svg" alt="giornaliera" style={{ height: '40px' }} />
  </button>
  <button className="btn-delete" onClick={() => setVistaDocumenti({ tipo: 'foto', dipendente: dip })}>
      <img src="/icon-foto.svg" alt="foto cantiere" style={{ height: '40px' }} />
  </button>
  <button className="btn-delete" onClick={() => setVistaDocumenti({ tipo: 'creaBolla', dipendente: dip })}>
      <img src="/icon-bolle.svg" alt="bolle" style={{ height: '40px' }} />
  </button>
</p>
</div>

              </div>
            ))}
          </div>
        </>

      )}

      {/* Modal per creare/modificare */}
      {showModal && (
        <div className="modal-overlay" onClick={chiudiModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>{editingId ? 'Modifica Dipendente' : 'Nuovo Dipendente'}</h3>
            
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nome *</label>
                <input
                  type="text"
                  value={formData.nome}
                  onChange={(e) => setFormData({...formData, nome: e.target.value})}
                  placeholder="Inserisci nome"
                  required
                />
              </div>

              <div className="form-group">
                <label>Cognome *</label>
                <input
                  type="text"
                  value={formData.cognome}
                  onChange={(e) => setFormData({...formData, cognome: e.target.value})}
                  placeholder="Inserisci cognome"
                  required
                />
              </div>

              <div className="modal-buttons">
                <button type="button" className="btn-cancel" onClick={chiudiModal}>
                  Annulla
                </button>
                <button type="submit" className="btn-save">
                  {editingId ? 'Salva Modifiche' : 'Crea Dipendente'}
                </button>
              </div>

	     <div className="form-group">
  <label>
    Email {!editingId && <span style={{color: 'red'}}>*</span>}
  </label>
  <input
    type="email"
    value={formData.email}
    onChange={e => setFormData({...formData, email: e.target.value})}
    placeholder="email dipendente"
    disabled={!!editingId}  // non modificabile in edit (cambiarla romperebbe l'auth)
  />
  {editingId && (
    <small style={{color: '#888'}}>
      L'email non è modificabile dopo la creazione
    </small>
  )}
</div>

            </form>
          </div>
        </div>
      )}

      {/* Modal Report Dipendente */}
      {showReportModal && dipendenteSelezionato && (
        <div className="modal-overlay" onClick={chiudiReportModal}>
          <div 
            className="modal-content" 
            onClick={(e) => e.stopPropagation()}
            style={{maxWidth: '90%', maxHeight: '90vh', overflow: 'auto'}}
          >
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px'}}>
              <h3 style={{margin: 0}}>📊 Report Programmi - {dipendenteSelezionato.nome} {dipendenteSelezionato.cognome}</h3>
              <button 
                onClick={chiudiReportModal}
                style={{
                  background: '#e74c3c',
                  border: 'none',
                  color: 'white',
                  padding: '8px 15px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '18px',
                  height: 'fit-content'
                }}
              >
                ✕
              </button>
            </div>


            {programmiDipendente.length === 0 ? (
              <div style={{textAlign: 'center', padding: '40px', color: '#7f8c8d'}}>
                <p>Nessun programma lavorativo trovato per questo dipendente.</p>
              </div>
            ) : (
              <>
                {/* 👇 Riga gialla con bottone PDF */}
                <div style={{
                  background: '#efd400',
                  padding: '15px',
                  borderRadius: '8px',
                  marginBottom: '20px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '10px'
                }}>
                  <strong>Totale programmi: {programmiDipendente.length}</strong>
                  
                  <PulsantiCondivisionePDF
                    documentoPDF={<ReportDipendentePDF dipendente={dipendenteSelezionato} programmi={getProgrammiOrdinati()} />}
                    nomeFile={`Report_Dipendente_${dipendenteSelezionato.cognome}_${dipendenteSelezionato.nome}.pdf`}
                    testoCondivisione={`📊 Report Programmi Lavorativi\n\n👤 ${dipendenteSelezionato.nome} ${dipendenteSelezionato.cognome}\n📋 ${programmiDipendente.length} programmi totali`}
                    emailDestinatario=""
                    oggettoEmail={`Report Dipendente - ${dipendenteSelezionato.cognome} ${dipendenteSelezionato.nome}`}
                    corpoEmail={`Buongiorno,\n\nallego il report completo dei programmi lavorativi per:\n\nDIPENDENTE: ${dipendenteSelezionato.nome} ${dipendenteSelezionato.cognome}\nTOTALE PROGRAMMI: ${programmiDipendente.length}\n\nCordiali saluti`}
                  />
                </div>

                {/* 👇 TABELLA DESKTOP (nascosta su mobile) */}
                <div style={{overflowX: 'auto'}} className="desktop-only">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th 
                          onClick={() => handleOrdinamentoReport('data')}
                          style={{cursor: 'pointer', userSelect: 'none'}}
                        >
                          Data {getFrecciaReport('data')}
                        </th>
                        <th>Orario Inizio</th>
                        <th>Orario Fine</th>
                        <th>Durata</th>
                        <th 
                          onClick={() => handleOrdinamentoReport('veicolo')}
                          style={{cursor: 'pointer', userSelect: 'none'}}
                        >
                          Veicolo {getFrecciaReport('veicolo')}
                        </th>
                        <th 
                          onClick={() => handleOrdinamentoReport('cliente')}
                          style={{cursor: 'pointer', userSelect: 'none'}}
                        >
                          Cliente {getFrecciaReport('cliente')}
                        </th>
                        <th 
                          onClick={() => handleOrdinamentoReport('cantiere')}
                          style={{cursor: 'pointer', userSelect: 'none'}}
                        >
                          Cantiere {getFrecciaReport('cantiere')}
                        </th>
                        <th>Note</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getProgrammiOrdinati().map(prog => {

                        const veicolo = getVeicolo(prog.veicoloId);
                        const cantiere = getCantiere(prog.cantiereId);
                        const cliente = getCliente(prog.cantiereId);

                        return (
                          <tr key={prog.id}>
                            <td><strong>{formattaData(prog.data)}</strong></td>
                            <td>{prog.orarioInizio}</td>
                            <td>{prog.orarioFine}</td>
                            <td><strong>{prog.durataLavoro}</strong></td>
                            <td>
                              {veicolo ? (
                                <>
                                  {veicolo.marca} {veicolo.modello}
                                  <br/>
                                  <small style={{color: '#666'}}>({veicolo.targa})</small>
                                </>
                              ) : 'N/D'}
                            </td>
                            <td>{cliente ? cliente.ragioneSociale : 'N/D'}</td>
                            <td>{cantiere ? cantiere.luogo : 'N/D'}</td>
                            <td style={{maxWidth: '200px', fontSize: '12px'}}>
                              {prog.note || '-'}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {/* 👇 LAYOUT CARD MOBILE (nascosto su desktop) */}
                <div className="mobile-cards">
                  {getProgrammiOrdinati().map(prog => {
                    const veicolo = getVeicolo(prog.veicoloId);
                    const cantiere = getCantiere(prog.cantiereId);
                    const cliente = getCliente(prog.cantiereId);

                    return (
                      <div key={prog.id} className="mobile-card">
                        <div className="mobile-card-header">
                          📅 {formattaData(prog.data)}
                        </div>
                        
                        <div className="mobile-card-row">
                          <span className="mobile-card-label">🕐 Orario:</span>
                          <span className="mobile-card-value">
                            {prog.orarioInizio} - {prog.orarioFine}
                          </span>
                        </div>

                        <div className="mobile-card-row">
                          <span className="mobile-card-label">⏱️ Durata:</span>
                          <span className="mobile-card-value">
                            <strong>{prog.durataLavoro}</strong>
                          </span>
                        </div>

                        <div className="mobile-card-row">
                          <span className="mobile-card-label">🚗 Veicolo:</span>
                          <span className="mobile-card-value">
                            {veicolo ? `${veicolo.marca} ${veicolo.modello} (${veicolo.targa})` : 'N/D'}
                          </span>
                        </div>

                        <div className="mobile-card-row">
                          <span className="mobile-card-label">🏢 Cliente:</span>
                          <span className="mobile-card-value">
                            {cliente ? cliente.ragioneSociale : 'N/D'}
                          </span>
                        </div>

                        <div className="mobile-card-row">
                          <span className="mobile-card-label">🏗️ Cantiere:</span>
                          <span className="mobile-card-value">
                            {cantiere ? cantiere.luogo : 'N/D'}
                          </span>
                        </div>

                        {prog.note && (
                          <div className="mobile-card-row">
                            <span className="mobile-card-label">📝 Note:</span>
                            <span className="mobile-card-value" style={{fontSize: '12px'}}>
                              {prog.note}
                            </span>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        </div>
      )}


      {vistaDocumenti && vistaDocumenti.tipo === 'bolle' && (
        <VisualizzaBolle
          dipendente={vistaDocumenti.dipendente}
          onClose={() => setVistaDocumenti(null)}
        />
      )}
      {vistaDocumenti && vistaDocumenti.tipo === 'giornaliera' && (
        <VisualizzaGiornaliera
          dipendente={vistaDocumenti.dipendente}
          onClose={() => setVistaDocumenti(null)}
        />
      )}
      {vistaDocumenti && vistaDocumenti.tipo === 'foto' && (
        <VisualizzaFotoCantiere
          dipendente={vistaDocumenti.dipendente}
          onClose={() => setVistaDocumenti(null)}
        />
      )}

      {vistaDocumenti && vistaDocumenti.tipo === 'creaBolla' && (
  <VisualizzaBolleForm
    dipendente={vistaDocumenti.dipendente}
    onClose={() => setVistaDocumenti(null)}
  />
)}


{showPasswordModal && dipPasswordSelezionato && (
  <div className="modal-overlay" onClick={() => setShowPasswordModal(false)}>
    <div className="modal-content" style={{ maxWidth: 420 }} onClick={e => e.stopPropagation()}>
      <h3>🔑 Credenziali — {dipPasswordSelezionato.nome} {dipPasswordSelezionato.cognome}</h3>
      <div style={{ padding: '16px 0' }}>
        <div className="form-group">
          <label>📧 Email</label>
          <input
            type="text"
            readOnly
            value={dipPasswordSelezionato.email || '—'}
            onClick={e => e.target.select()}
            style={{ cursor: 'pointer', background: '#f8f9fa' }}
          />
          <small style={{ color: '#27ae60' }}>Clicca per selezionare</small>
        </div>
        <div className="form-group" style={{ marginTop: 16 }}>
          <label>🔑 Password</label>
          <input
            type="text"
            readOnly
            value={dipPasswordSelezionato.passwordTemp || 'Non disponibile'}
            onClick={e => e.target.select()}
            style={{ cursor: 'pointer', background: '#f8f9fa', fontFamily: 'monospace', fontSize: 16, fontWeight: 700 }}
          />
          <small style={{ color: '#27ae60' }}>Clicca per selezionare</small>
        </div>
        <button
          onClick={() => {
            const testo = `Email: ${dipPasswordSelezionato.email}\nPassword: ${dipPasswordSelezionato.passwordTemp}`;
            navigator.clipboard.writeText(testo);
            alert('Credenziali copiate negli appunti!');
          }}
          className="btn-save"
          style={{ width: '100%', marginTop: 16 }}
        >
          📋 Copia tutto negli appunti
        </button>
        <button onClick={() => setShowPasswordModal(false)} className="btn-cancel" style={{ width: '100%', marginTop: 8 }}>
          Chiudi
        </button>
      </div>
    </div>
  </div>
)}


    </div>
  );
}

export default ListaDipendenti;
